import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpEvent, HttpRequest, HttpHandler, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AppError } from '../interfaces/app-error';
import { ErrorType } from '../enums/app-error-type';
import { JWTService } from '../services/jwt.service';
import { environment } from '../../environments/environment';
import { SessionService } from '../services/session.service';
import { throwToolbarMixedModesError } from '@angular/material';

@Injectable()
export class APIInterceptor implements HttpInterceptor {

  constructor(
    private jwtService:JWTService, 
    private sessionService: SessionService
  ){}

  intercept(
    httpRequest: HttpRequest<any>,
    next: HttpHandler): Observable<HttpEvent<any>> {

    //REQUEST
    if (/^(http|https):/i.test(httpRequest.url)) {
      // const isApiUrl = httpRequest.url.startsWith(environment.apiUri);
      if(this.isApiCall(httpRequest.url)) {
        httpRequest = httpRequest.clone({
          url: httpRequest.url,
          setHeaders: this.addExtraHeaders()
        });
      }
    }

    //RESPONSE
    return next.handle(httpRequest)
      .pipe(
        map((event: any) => {
          const generalErrorCode = "-1";

          if (event instanceof HttpResponse) {

            if (event.url) {
              if (this.isApiCall(event.url) && typeof event.body === 'object') {

                this.extendLocalSession();

                //detect server session expire and handle logout process
                this.handleSessionExpire(event.body.data);

                //save new JWT
                this.handleJWTResopne(event.headers);

                if (!event.body.isFail && event.body.data) {
                  event = event.clone({ body: event.body.data });
                } else {
                  if(event.body.msgCode) {
                    throw new Error(event.body.msgCode);
                  } else {
                    throw new Error(generalErrorCode);
                  }
                }
              }
            } else {
              throw new Error(generalErrorCode);
            }
          }

          return event;
        }),
        catchError((errorCode) => {
          let error: AppError = {
            type: ErrorType.ERROR,
            code: errorCode,
            // msg: errorMsg
          };

          // console.warn(`API INTERCEPTOR(): error", ${error.msg}`);

          throw error;
        })
      );
  }

  private isApiCall(url):boolean {
    let ret:boolean = false
    const apiUriPart =  environment.route; 
    if(url) {
      ret = (url.toLowerCase().includes(apiUriPart.toLowerCase()));
    }

    return ret;
  }

  private addExtraHeaders() {
    let headers = {
      'Content-Type': 'application/json',
      'X-Client-Version': environment.common.appVersion,
    };

    const jwt = this.jwtService.getToken();
    if(jwt && jwt.length > 0) {
      headers[JWTService.JWT_KEY] = jwt;
    }
    return headers;
  }

  private handleJWTResopne(headers) {
    const jwt = headers.get(JWTService.JWT_KEY);
    if(jwt) {
      this.jwtService.setToken(jwt);
    }
  }

  private handleSessionExpire(res) {
    const isJwtExpired = (res && res.msgCode === JWTService.JWT_EXPIRED_MSG_CODE);
    if (isJwtExpired) {
      console.log("%c😭 JWT expired!", "font-size:20px;color:red");
      this.sessionService.onSessionExpire.next(true);
    }
  }

  private extendLocalSession() { 
    this.sessionService.onSuccessfullCallToApi.next(true);
  }

}



// WEBPACK FOOTER //
// ./src/app/interceptors/api.interceptor.ts